export default (registrationComplete, subscription) => {
  if (!subscription || subscription.length === 0 || subscription.plan_status !== 'active') return true;
  if (!registrationComplete || (subscription && subscription?.is_paid)) return false;

  return !(subscription && subscription?.is_paid);
};
